<div class="durations-block">
    <div class="post-title">{{activity.title}}</div>
    <div class="email-input-text" *ngFor="let duration of activity.durations">
        <div class="input-label" *ngIf="displayComplexity">{{duration.complexity.name}}</div>
        <input *ngIf="!wa" class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="duration.hours">
        <input *ngIf="wa" class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="duration.hoursWA">

    </div>
</div>
